import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import VerificationInputField from "components/VerificationInputField";
import { useMutation, useLazyQuery } from "@apollo/client";
import { VALIDATE_STAFF_PIN, UPDATE_STAFF_PIN } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import { message } from "antd";

const ModalChangePIN = ({
  hidden,
  buttonStyle,
  staffId
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [currentPINEntered, setCurrentPINEntered] = useState(false);
  const [currentPIN, setCurrentPIN] = useState(["", "", "", "", "", ""]);
  const [newPIN, setNewPIN] = useState(["", "", "", "", "", ""]);
  const [currentPINError, setCurrentPINError] = useState(false);
  const [newPINError, setNewPINError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [validateStaffPIN, { loading: verifyLoading }] = useLazyQuery(VALIDATE_STAFF_PIN, {
    onCompleted: (data) => {
      setCurrentPINEntered(true);
      setCurrentPINError(false);
    },
    onError: (error) => {
      setCurrentPINError(true);
      setErrorMessage("Incorrect PIN. Please try again.");
    }
  });

  const [updateStaffPIN, { loading: updateLoading }] = useMutation(UPDATE_STAFF_PIN, {
    onCompleted: (data) => {
      message.success("PIN updated successfully!");
      setIsOpen(false);
      setCurrentPIN(["", "", "", "", "", ""]);
      setNewPIN(["", "", "", "", "", ""]);
      setCurrentPINEntered(false);
      setNewPINError(false);
    },
    onError: (error) => {
      setNewPINError(true);
      setErrorMessage(error.message || "An error occurred while updating the PIN. Please try again.");
    }
  });

  const handleContinue = () => {
    if (verifyLoading) return;
    if (currentPIN.join('').trim() === "" || currentPIN.length !== 6) {
      setCurrentPINError(true);
      return;
    }
    validateStaffPIN({
      variables: {
        pin: currentPIN.join('')
      }
    });
  };

  const handleChangePIN = () => {
    if (updateLoading) return;
    if (newPIN.join('').trim() === "" || newPIN.length !== 6) {
      setNewPINError(true);
      return;
    }
    updateStaffPIN({
      variables: {
        staffId: staffId, 
        input: {
          currentPin: currentPIN.join(''),
          pin: newPIN.join('')
        }
      }
    });
  };

  console.log("Current PIN:", currentPIN);
  console.log("New PIN:", newPIN);

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setClose={() => {
          setIsOpen(false);
          setCurrentPIN(["", "", "", "", "", ""]);
          setNewPIN(["", "", "", "", "", ""]);
          setCurrentPINEntered(false);
          setCurrentPINError(false);
          setNewPINError(false);
        }}
        className="modal-success"
        buttonLabel="Change PIN"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>
          {currentPINEntered ? "Enter New PIN" : "Enter Current PIN"}
        </Head>
        <Container>
          <div className="text">
            {currentPINEntered ? "Please choose a new 6-digit PIN to update your PIN. (Numbers only, no letters or symbols)." : "Please enter your current PIN."}
          </div>
          {currentPINEntered? <VerificationInputField
            title="6-DIGIT PIN"
            required
            width="320px"
            length={6}
            values={newPIN}
            setValues={(values) => {
              setNewPIN(values)
              setNewPINError(false)
              setErrorMessage("")
            }}
            error={newPINError}
            errorMessage={errorMessage}
          />: <VerificationInputField
            title="6-DIGIT PIN"
            required
            width="320px"
            length={6}
            values={currentPIN}
            setValues={(values) => {
              setCurrentPIN(values)
              setCurrentPINError(false)
              setErrorMessage("")
            }}
            error={currentPINError}
            errorMessage={errorMessage}
          />}
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onClick={currentPINEntered ? handleChangePIN : handleContinue}
            data-loading={verifyLoading || updateLoading}
          >
            {(verifyLoading || updateLoading) ? null : "Continue"}
          </Button>
        </Footer>
      </MainModal>
    </>
  );
};

export default ModalChangePIN;